define('gigaset_recurring/classes/provider/billwerk/steps/address/_abstract',[
	"jquery",
	"lodash",
	"../_abstract",
	"cartware/jquery/bem",
	"cartware/components/Registry",
	"cartware/components/Logger",
	"jquery-serialize-object"
], function(
	$,
	_,
	AbstractStep,
	BEM,
	Registry,
	Logger
) {

	function AddressStep() {
		AbstractStep.call(this);

		this.initializedMethodsMap = {};
		this.logger = Logger.getLogger("gigaset_recurring.address.abstract");
		this.rootElement = $(document.body);
	}

	AddressStep.ADDRESS_SOURCE_CURRENT = "current";
	AddressStep.ADDRESS_SOURCE_DIFFERENT = "different";

	AddressStep.prototype = _.create(new AbstractStep, {
		constructor: AddressStep,

		currentAddressSource: "different",
		currentAddressCreate: false,
		currentAddressFormKey: "default",
		formDataKey: "address",

		initialize: function() {
			this.block = BEM.block(this.rootElement.find("." + BEM.buildBlockClassname("gigaset-recurring-checkout-address")));

			this.proceedButton = this.block.getElements("proceed-button");
			this.backButton = this.block.getElements("back-button");
			this.addressSource = this.block.getElements("address-source");

			this.addressCurrent = this.block.getElements("address-current");
			this.addressDifferent = this.block.getElements("address-different");

			this.addressChooserCurrent = this.addressCurrent.find("." + BEM.buildBlockClassname("customer-address-chooser"));
			this.addressChooserDifferent = this.addressDifferent.find("." + BEM.buildBlockClassname("customer-address-chooser"));

			this.addressCreate = this.block.getElements("create-address");
			this.addressNew = this.block.getElements("new-address");

			this.form = this.block.getElements("form");
			this.formValidate = new Validation(this.form.get(0));

			this.address = {
				"current": null,
				"different": null,
				"new": null
			};

			this.bindEvents();
			this.onAddressSourceChange();
			this.onAddressCreateChange();
			this.onAddressChooserCurrentChange();
			this.onAddressChooserDifferentChange();
		},

		onAddressSourceChange: function(e) {
			var value = this.addressSource.filter(':checked,[type=hidden]').val()|0;

			this.currentAddressSource = value ? AddressStep.ADDRESS_SOURCE_DIFFERENT : AddressStep.ADDRESS_SOURCE_CURRENT;

			if (this.currentAddressSource === AddressStep.ADDRESS_SOURCE_CURRENT) {
				// this.addressCurrent.show();
				this.addressChooserCurrent.bemRemoveModifier("disabled");
				this.addressDifferent.hide();
			} else if (this.currentAddressSource === AddressStep.ADDRESS_SOURCE_DIFFERENT) {
				// this.addressCurrent.hide();
				this.addressChooserCurrent.bemAddModifier("disabled");
				this.addressDifferent.show();
			}

			this.emit("layout");
		},

		onAddressCreateChange: function() {
			var value = this.addressCreate.filter(":checked,[type=hidden]").val()|0;

			this.currentAddressCreate = value;

			if (this.currentAddressCreate) {
				this.addressNew.show();
				this.addressChooserDifferent.bemAddModifier("disabled");
			} else {
				this.addressNew.hide();
				this.addressChooserDifferent.bemRemoveModifier("disabled");
			}

			this.emit("layout");
		},

		onAddressChooserCurrentChange: function() {
			var value = this.addressChooserCurrent.find('input[name=' + this.currentAddressFormKey + ']:checked').val();
			this.address.current = value;
		},

		onAddressChooserDifferentChange: function() {
			var value = this.addressChooserDifferent.find('input[name=local]:checked').val();
			this.address.different = value;
		},

		bindEvents: function() {
			this.addressChooserCurrent.on("change", _.bind(this.onAddressChooserCurrentChange, this));
			this.addressChooserDifferent.on("change", _.bind(this.onAddressChooserDifferentChange, this));
			this.addressSource.on("change", _.bind(this.onAddressSourceChange, this));
			this.addressCreate.on("change", _.bind(this.onAddressCreateChange, this));
			// this.proceedButton.on("click", _.bind(this.submit, this));
			this.backButton.on("click", _.bind(this.previous, this));
			this.form.on("submit", _.bind(function(e) {
				e.preventDefault();
				this.submit();
			}, this));
		},

		collectFormData: function() {
			var address = null;
			var result = {};

			if (this.currentAddressSource === AddressStep.ADDRESS_SOURCE_CURRENT) {
				address = {
					"type": this.currentAddressFormKey,
					"id": _.trim(this.address.current)
				};
			} else if (this.currentAddressSource === AddressStep.ADDRESS_SOURCE_DIFFERENT) {
				if (this.currentAddressCreate) {
					address = {
						"type": "new",
						"data": this.form.serializeObject()
					};
				} else {
					address = {
						"type": "local",
						"id": _.trim(this.address.different)
					};
				}
			}

			result[this.formDataKey] = address;

			return result;
		},

		/**
		 * Collect data from the step and save it via this.addData
		 * @returns {Promise}
		 */
		saveFormData: function() {
			this.proceedButton.button("loading");
			return this.saveFormDataServerSide()
				.always(_.bind(function() {
					this.proceedButton.button("reset");
				}, this))
				.fail(_.bind(function(response) {
					var qaddress = _.get(response, "qaddress");
					if (_.isObject(qaddress)) {
						this.form.find('[name="address_source"][value="1"]').prop("checked", "checked").trigger("change");
						this.form.find('[name="create_address"][value="1"]').prop("checked", "checked").trigger("change");

						_.forEach(qaddress, _.bind(function(value, key) {
							if (_.isArray(value)) {
								this.form.find('[name="' + key + '[]"]').each(function(i, node) {
									$(node).val(_.get(value, i, ''));
								});
							} else {
								this.form.find('[name="' + key + '"]').val(value);
							}
						}, this));
					}
				}, this));
		}

	});

	return AddressStep;

});
